export const LOGO_URL = "https://customer-assets.emergentagent.com/job_6878f9b3-c0f1-439b-b79d-7254bda0f5aa/artifacts/uj9x8p91_logo.jpeg";

export const megaMenuData = {
  Présentation: {
    image: "/images/photo-1600585154340.jpg",
    items: [
      { path: "/expertise", label: "Qui sommes-nous", desc: "Notre histoire, notre équipe et nos valeurs" },
      { path: "/notre-methode", label: "Notre méthode", desc: "Un processus en 5 étapes éprouvé et transparent" },
      { path: "/faq", label: "Questions fréquentes", desc: "Tout savoir sur nos services et tarifs" },
    ],
    cta: { label: "Découvrir notre expertise", path: "/expertise" },
  },
  Propriétaires: {
    image: "/images/photo-1560448204.jpg",
    items: [
      { path: "/sous-location", label: "Offre Sérénité", desc: "Sous-location pro — loyer garanti chaque mois" },
      { path: "/conciergerie-privee", label: "Offre Partenariat", desc: "Conciergerie haut de gamme sur commission" },
      { path: "/simulateur", label: "Simulateur de revenus", desc: "Estimez le potentiel de votre bien" },
      { path: "/contact", label: "Devenir partenaire", desc: "Contactez-nous pour un premier échange" },
    ],
    cta: { label: "Confier mon bien", path: "/proprietaires#contact-form" },
  },
  Voyageurs: {
    image: "/images/photo-1522708323590.jpg",
    items: [
      { path: "/voyageurs", label: "Nos logements", desc: "Appartements et maisons à Limoges et Évaux" },
      { path: "/blog/limoges-10-incontournables-pour-un-sejour-inoubliable", label: "Guide Limoges", desc: "10 incontournables pour un séjour inoubliable" },
      { path: "/blog/evaux-les-bains-guide-complet-pour-votre-cure-thermale", label: "Guide Évaux-les-Bains", desc: "Guide complet pour votre cure thermale" },
    ],
    cta: { label: "Réserver un logement", path: "/voyageurs" },
  },
};

export const navLinks = [
  { path: "/", label: "Accueil" },
  { label: "Présentation", path: "/expertise", hasMega: true },
  { label: "Propriétaires", path: "/proprietaires", hasMega: true },
  { label: "Voyageurs", path: "/voyageurs", hasMega: true },
  { path: "/blog", label: "Blog" },
  { path: "/contact", label: "Contact" },
];
